import { render } from "./LightboxCategoryStoresSkeleton.vue?vue&type=template&id=24108b17&scoped=true"
import script from "./LightboxCategoryStoresSkeleton.vue?vue&type=script&lang=js"
export * from "./LightboxCategoryStoresSkeleton.vue?vue&type=script&lang=js"

import "./LightboxCategoryStoresSkeleton.vue?vue&type=style&index=0&id=24108b17&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24108b17"]])

export default __exports__